import { useState, useEffect } from "react";
import {
	Button,
	Card,
	CardContent,
	CardMedia,
	Typography,
	Grid,
	Collapse,
	Divider,
	Hidden,
	FormHelperText,
	Tooltip,
	DialogContent,
	DialogContentText,
	DialogActions,
	DialogTitle,
	Dialog,
	useMediaQuery,
} from "@mui/material";
import CompletePurchase from "./CompletePurchase";
import styles from "../../styles";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useTheme } from "@mui/material/styles";

const classes: any = {
	root: {
		display: "flex",
		height: "100%",
		marginTop: 1,
		marginBottom: 1,
	},
	dialog: {
		overflowY: "hidden",
		overflowX: "hidden",
	},
	content: {
		flex: "1 0 auto",
		paddingTop: 0,
	},
	cover: {
		width: 120,
		height: 103,
		position: "relative",
	},
	cartHeader: {
		backgroundColor: "primary.main",
		color: "white",
		padding: 1,
		borderRadius: 5,
		letterSpacing: 1,
	},
	button: {
		marginTop: 1,
		marginBottom: 2,
	},
	store: {
		marginTop: 10,
		maxWidth: 600,
		marginLeft: "auto",
		marginRight: "auto",
	},
	quantity: {
		width: 20,
		minWidth: 0,
		backgroundColor: "white",
		color: "secondary.main",
		fontWeight: 900,
		boxShadow: "none",
		borderRadius: 0,
	},
	overlay: {
		position: "absolute",
		top: 5,
		left: 5,
		color: "#0000008A",
		cursor: "pointer",
	},
	secondary: {
		color: "secondary.main",
	},
	users: {
		width: 100,
		display: "flex",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: { xs: 2.5, md: 1.5, marginBottom: 2 },
	},
};

export default function Cart(props: any) {
	const [collapse, setCollapse] = useState<boolean>(false);
	const [open, setOpen] = useState<number>(0);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down("sm"));
	const { index, cart, item, cartItems, setCartItems } = props
	useEffect(() => {
		setCollapse(true);
	}, [collapse]);

	const handleClose = () => {
		setOpen(0);
	};
	const deleteItem = (id: any) => {
		const newCart = cartItems.filter((item: any) => item.productId !== id)
		setCartItems(newCart)
	}
	const addQuantity = (id: any) => {
		console.log("id", id)
		console.log("cartItems", cartItems)
		const newItem: any = cartItems.find((item: any) => Number(item.productId) === Number(id))
		console.log("newITem", newItem)
		newItem.quantity = newItem?.quantity + 1
		console.log("newITem2", newItem)
		const cart = cartItems.filter((item: any) => Number(item.productId) !== Number(id))
		console.log("cart", cart)
		cart.push(newItem)
		console.log("cart2", cart)
		cart.sort((a: any, b: any) => a.productId - b.productId)
		setCartItems(cart)
	}
	const subtractQuantity = (id: any) => {
		const newItem = cartItems.find((item: any) => item.productId == id)
		newItem.quantity = newItem.quantity - 1
		const cart = cartItems.filter((item: any) => item.productId != id)
		cart.push(newItem)
		cart.sort((a: any, b: any) => a.productId - b.productId)
		setCartItems(cart)
	}
	const clearCart = () => {
		setCartItems([])
		setOpen(0)
	}

	const getSubTotal = () => {
		let subtotal = 0

		cartItems.forEach((item: any) => {
			subtotal = subtotal + (item.amount * item.quantity)
		})
		return subtotal
	}
	console.log("cartITems", cartItems)
	const subTotal = getSubTotal()
	console.log("st", subTotal)
	return (
		<>
			<DialogTitle sx={{ p: 0 }}>
				<Grid container justifyContent="space-between" sx={{ backgroundColor: "#252525" }}>
					<Hidden mdDown>
						<Grid item xs={3} />
					</Hidden>
					<Grid item xs={5}>
						<Typography
							sx={{ mb: 1, pl: 2, mt: 1 }}
							variant="h5"
							align="center"
							color="primary.contrastText"
						>
							Shopping Cart
						</Typography>
					</Grid>
					<Grid item xs={4}>
						<Typography color="primary.contrastText" align="right" sx={{ mb: 1, mr: 1, mt: 1 }}>
							{cartItems?.length > 0 ? (
								<Button color="secondary" variant="outlined" onClick={() => setOpen(2)}>
									Clear
								</Button>
							) : null}
						</Typography>
					</Grid>
				</Grid>
			</DialogTitle>
			<Divider />
			<DialogContent sx={{ p: 1, pt: 0 }}>
				<DialogContentText>
					<Grid container justifyContent="space-between" direction="column">
						<Grid item>
							<Collapse in={collapse} timeout={1000}>
								{cartItems?.length > 0 ? (
									cartItems?.map((item: any, index: any) => (
										<div key={index}>
											<Card
												raised
												sx={{
													m: 2,
													borderRadius: 3,
													position: "relative",
												}}
											>
												<CardContent style={{ padding: 0 }}>
													<Grid
														container
														justifyContent="space-between"
														style={{ backgroundColor: "rgba(129,130,133,.05)" }}
													>
														<Grid item>
															<CardMedia
																component="img"
																sx={classes.cover}
																src={
																	item?.imageUrl
																		? item.imageUrl
																		: props.defaultImage
																}
																title={item?.name}
															/>
															<Typography sx={classes.overlay}>
																<DeleteOutlinedIcon
																	onClick={() => deleteItem(item.productId)}
																	className="material-icons"
																	color="secondary"
																/>
															</Typography>
														</Grid>
														<Grid item sx={{ maxWidth: 250, padding: 0.5 }}>
															<Typography
																variant="subtitle1"
																color="primary.contrastText"
																sx={{
																	lineHeight: 1.2,
																	minWidth: 150,
																	maxWidth: 160,
																}}
															>
																{item.name?.length < 20 ? (
																	item.name
																) : (
																	<Tooltip
																		arrow
																		placement="top"
																		title={item.name}
																		style={{ cursor: "pointer" }}
																	>
																		<Typography color="primary.contrastText">
																			{item.name?.slice(0, 19) + "..."}
																		</Typography>
																	</Tooltip>
																)}
															</Typography>
															<Typography
																sx={{
																	alignItems: "left",
																	minWidth: 150,

																	fontSize: 18,
																	fontWeight: 500,

																}}
																color="secondary"
																variant="subtitle2"
															>

																${(item?.amount).toFixed(2)}

															</Typography>

														</Grid>
														<Grid item>
															<Grid item>
																<div
																	style={{
																		paddingBottom: 3,
																		justifyContent: "flex-end",
																		display: "flex",
																	}}
																>
																	<Button
																		sx={classes.quantity}
																		variant="contained"
																		onClick={() => addQuantity(item.productId)}
																		disabled={
																			item.cartQuantity === item.quantity
																		}
																	>
																		+
																	</Button>
																</div>
															</Grid>
															<Grid item>
																<Typography align="center" color="primary.contrastText">
																	<strong>
																		{item.quantity}
																	</strong>
																</Typography>
															</Grid>
															<Grid item>
																<div
																	style={{
																		marginTop: 3,
																		justifyContent: "flex-end",
																		display: "flex",
																	}}
																>
																	<Button
																		sx={classes.quantity}
																		variant="contained"
																		onClick={() => subtractQuantity(item.productId)}
																		disabled={item?.quantity === 1}
																	>
																		-
																	</Button>
																</div>
															</Grid>
														</Grid>
													</Grid>
													{item.cartQuantity > item.quantity ? (
														<FormHelperText sx={{ pl: 4, color: "red" }}>
															Quantity exceeds amount available ({item.quantity}
															)
														</FormHelperText>
													) : null}
												</CardContent>
											</Card>
										</div>
									))
								) : (
									<Typography color="primary.contrastText" align="center" sx={{ padding: 2 }}>
										Your cart is empty
									</Typography>
								)}
							</Collapse>
						</Grid>
						<Grid item>
							<div
								style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }}
							>
								<Dialog
									sx={styles.modal}
									open={open === 2}
									onClose={handleClose}
								>
									<Grid container justifyContent="center" sx={{ padding: 2 }}>
										<Grid item xs={12}>
											<Typography color="primary.contrastText" paragraph align="center">
												Are you sure you want to clear your cart?
											</Typography>
										</Grid>
										<Grid style={{ margin: 5 }} item xs={5}>
											<Button
												color="secondary"
												onClick={() => setOpen(0)}
												fullWidth
												variant="outlined"
											>
												NO
											</Button>
										</Grid>
										<Grid sx={{ margin: 0.5 }} item xs={5}>
											<Button
												color="secondary"
												onClick={clearCart}
												fullWidth variant="outlined">
												YES
											</Button>
										</Grid>
									</Grid>
								</Dialog>

								<Dialog
									open={open === 1}
									sx={styles.modal}
									maxWidth="sm"
									fullScreen={matches ? true : false}
									fullWidth={!matches ? true : false}
								>
									<CompletePurchase
										{...props}
										cartItems={cartItems}
										config={props.config}
										onClose={handleClose}
										setMessages={props.setMessages}
										subtotal={subTotal}
										closeCart={() => props.handleClose(false)}
										clearCart={clearCart}
									/>
								</Dialog>
							</div>
						</Grid>
					</Grid>
				</DialogContentText>
				<Typography color="primary.contrastText" sx={{ pb: 1, width: "100%" }} align="center" variant="h5">
					Subtotal: ${subTotal.toFixed(2)}
				</Typography>
			</DialogContent>
			<DialogActions sx={{ p: 2, pt: 0 }}>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Button
							onClick={() => props.handleClose(false)}
							color="secondary"
							variant="outlined"
							fullWidth
						>
							Back to Store
						</Button>
					</Grid>
					<Grid item xs={12}>
						<Button
							color="secondary"
							variant="contained"
							fullWidth
							onClick={() => setOpen(1)}
							disabled={cart?.length < 1}
						>
							Complete Purchase
						</Button>
					</Grid>
				</Grid>
			</DialogActions>
		</>
	);
}
